var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSnoozeV2 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M46.85 22.99c-3.6-6.39-11.07-9.92-18.29-8.4-8.15 1.71-13.52 9.03-13.72 17.18 0 .1-.01.19-.01.25s0 .15.01.25c.17 7.16 4.31 13.86 11.16 16.43 6.88 2.58 14.78.37 19.34-5.39 4.5-5.69 5.06-14.03 1.51-20.33Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color-monochrome-white)",
  d: "M31.38 21.2V32c0 .19.2 1.8.78 1.35 2.41-1.85 4.83-3.7 7.24-5.55l1.03-.79c.47-.36.5-1.18.43-1.72-.03-.24-.29-1.34-.76-.98-2.41 1.85-4.83 3.7-7.24 5.55l-1.03.79.78 1.35V21.2c0-.37-.07-1.38-.62-1.4s-.62 1.09-.62 1.4Z"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgSnoozeV2);
export default ForwardRef;